export const config: any = {
	drought: {
		"2030": "AE",
		"2035": "AF",
		"2040": "AG",
		"2045": "AH",
		"2050": "AI",
		"2055": "AJ",
		"2060": "AK",
		"2070": "AL",
		"2085": "AM",
	},
	drought_old: {
		"2030": "AE",
		"2035": "AF",
		"2040": "AG",
		"2045": "AH",
		"2050": "AI",
		"2055": "AJ",
		"2060": "AK",
		"2070": "AL",
		"2085": "AM",
	},
	extreme_precipitation: {
		"2030": "AO",
		"2035": "AP",
		"2040": "AQ",
		"2045": "AR",
		"2050": "AS",
		"2055": "AT",
		"2060": "AU",
		"2070": "AV",
		"2085": "AW",
	},
	extreme_precip_fluvial_flood: {
		"2030": "AY",
		"2035": "AZ",
		"2040": "BA",
		"2045": "BB",
		"2050": "BC",
		"2055": "BD",
		"2060": "BE",
		"2070": "BF",
		"2085": "BG",
	},
	extreme_precip_pluvial_flood: {
		"2030": "BI",
		"2035": "BJ",
		"2040": "BK",
		"2045": "BL",
		"2050": "BM",
		"2055": "BN",
		"2060": "BO",
		"2070": "BP",
		"2085": "BQ",
	},
	heat_wave: {
		"2030": "BS",
		"2035": "BT",
		"2040": "BU",
		"2045": "BV",
		"2050": "BW",
		"2055": "BX",
		"2060": "BY",
		"2070": "BZ",
		"2085": "CA",
	},
	wind: {
		"2030": "CC",
		"2035": "CD",
		"2040": "CE",
		"2045": "CF",
		"2050": "CG",
		"2055": "CH",
		"2060": "CI",
		"2070": "CJ",
		"2085": "CK",
	},
	sea_level_rise: {
		"2030": "CM",
		"2035": "CN",
		"2040": "CO",
		"2045": "CP",
		"2050": "CQ",
		"2055": "CR",
		"2060": "CS",
		"2070": "CT",
		"2085": "CU",
	},
	heat_stress: {
		"2030": "CW",
		"2035": "CX",
		"2040": "CY",
		"2045": "CZ",
		"2050": "DA",
		"2055": "DB",
		"2060": "DC",
		"2070": "DD",
		"2085": "DE",
	},
	wild_fire: {
		"2030": "DG",
		"2035": "DH",
		"2040": "DI",
		"2045": "DJ",
		"2050": "DK",
		"2055": "DL",
		"2060": "DM",
		"2070": "DN",
		"2085": "DO",
	},
};
